var _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCaveBackBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 155,
    viewBox: "0 0 150 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33011 115.667L29.4511 135.059C29.8064 135.344 30.2485 135.5 30.7042 135.5H117.882C118.285 135.5 118.678 135.378 119.01 135.151L147.481 115.696C148.106 115.27 148.436 114.527 148.334 113.777L135.643 20.0555C135.554 19.3957 135.142 18.8236 134.544 18.5295L103.418 3.20566C103.143 3.07036 102.841 3 102.534 3H46.1425C45.7247 3 45.3174 3.13085 44.9777 3.37417L12.7497 26.4629C12.274 26.8037 11.9714 27.3358 11.9217 27.9189L4.59045 113.939C4.53391 114.602 4.8112 115.25 5.33011 115.667Z",
    fill: "url(#paint0_radial_885_7224)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_885_7224",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(77 49.5) rotate(90) scale(89 96.7245)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D5718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.942708,
    stopColor: "#0E0902"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaveBackBackground);
export default __webpack_public_path__ + "static/media/cave-back-background.161a86c69fca00fb0899e626cb70b2b4.svg";
export { ForwardRef as ReactComponent };